.driver-portal .driver-departure-simulation :is(input, select, button) {
  border-radius: 4px;
  min-height: 40px;
}
.driver-portal .driver-departure-simulation :is(input, select, button):focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
  box-shadow: none;
}
.driver-portal .driver-departure-test-toggle {
  flex-shrink: 0; min-height: 36px; padding: 4px 6px; border-radius: 4px;
  font-size: 11px; line-height: 1; letter-spacing: normal;
}
.driver-portal .driver-departure-test-toggle:focus-visible {
  outline: 2px solid var(--color-accent); outline-offset: 2px;
}
.driver-date-with-test { display: inline-flex; align-items: center; gap: 6px; }
@media (max-width: 420px) {
  .driver-portal-header--test [data-workspace-page-header] :has(> h1) > div:first-child:has([aria-hidden=true]) { display: none; }
  .driver-portal-header--test .driver-date-trigger { font-size: 16px; }
}
